export const LANG_EN_NAME = 'en';

export const LANG_EN_TRANS = {
    login: 'Log in',
    selectLanguage: 'Select language',
    profileChoose: 'Please choose your speciality and language',
    speciality: 'Speciality',
    language: 'Language',
    saveAndContinue: 'Save and Continue',
    capitalChoose: 'You can choose a capital here.',
    questions: 'QUESTIONS',
    question: 'Question',
    dashboard: 'OVERVIEW',
    logout: 'Logout',

    //Question buttons
    previous: 'Previous',
    next: 'Next',
    finish: 'Finish',
    checkAnswer: 'Check Answer',
    source: 'Source:',

    //Dashboard
    trackStatictics: 'Track your statictics',
    correct: 'Correct',
    wrong: 'Wrong',
    unanswered: 'Unanswered',
    percentCorrect: '% correct',
    capital: 'Capital',
    total: 'Total',
    practiceFailed: 'Practice failed questions',
    practiceUnanswered: 'Practice unanswered questions',
    resetQuestions: 'Reset all questions',
    resetQuestionNotification: 'Your answers have been reset.',
    resetNoQuestionNotification: 'You have no questions to reset',
    yes: 'Yes',
    no: 'No',
    resetConfirmMessage: 'Are you sure you want to delete all your answers?',
    wrongQuestionNotification: 'You do not have any wrong questions.',
    unansweredQuestionNotification: 'You do not have any unanswered questions.',
    anyQuestionNotification: 'You do not have any questions.',


    //Login
    emailValidError: 'Please input valid email adress',
    emailRequiredError: 'Please input your email adress',
    passwordInputError: 'Please input your password',
    password: 'Password',
    email: 'Email',
    forgotPassword: 'Forgot Password',
    passwordRecovery: 'Password Recovery',
    enterEmail: 'Please enter your e-mail and we’ll send you a new password',
    send: 'Send',
    forgotEmail: 'Forgot Email',
    checkEmail: 'Check your email',
    checkEmailMessage: 'We sent you an email, please check it to reset your password.',
    returnLogin: 'Return to login',
    contactMessage1: 'You can contact us at ',
    contactEmail: 'support@medexam.app',
    contactMessage2:' to recover your registered email.',
    noSendEmail: 'Email could not be sent. Please try again later.',
    setNewPassword: 'Set a new password',
    setNewPasswordHint: 'Enter a new password for your account.',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    passwordMismatch: 'Passwords do not match',
    savePassword: 'Save password',
    resetPasswordSuccess: 'Your password has been updated. You can now log in.',
    resetPasswordError: 'This reset link is invalid or has expired. Please request a new one.',

    correctPercentage: 'Correct percentage',

    // Guest demo
    demoTitle: 'Try 10 free questions',
    demoIntro: 'Answer 10 practice questions with no registration or payment. The full question bank stays available after you purchase access.',
    demoStart: 'Start demo',
    demoContinue: 'Continue demo',
    demoFreeQuestions: 'Try 10 free questions',
    demoLoginLink: 'Log in',
    demoBadge: 'Free demo',
    demoOf: 'of',
    demoFallbackNotice: 'Showing sample questions because the guest API is not available yet.',
    demoUnavailable: 'The demo is temporarily unavailable. Please try again later.',
    demoFinishedTitle: 'Demo finished',
    demoFinishedLead: 'You have used your 10 free questions. Unlock the full exam question bank to keep practising.',
    demoScoreCaption: 'correct answers',
    demoPurchaseCta: 'Buy exam questions',
    demoAlreadyCompleted: 'You have already completed the 10 free questions in this browser.',
    demoSeeResults: 'See results',

    // Mock exam
    mockTest: 'MOCK TEST',
    mockIntro: 'Timed simulation of EDAIC Part 1: Paper A (Basic Sciences) and Paper B (Clinical Practice).',
    mockRuleQuestions: '60 questions, each with up to 5 true/false statements',
    mockRuleScoring: '1 point per correctly judged statement, no negative marks; a blank scores 0',
    mockRuleFeedback: 'No feedback until the end of the exam',
    mockPaperA: 'Paper A',
    mockPaperATitle: 'Basic Sciences',
    mockPaperATopic1: 'Physiology',
    mockPaperATopic2: 'Pharmacology',
    mockPaperATopic3: 'Physics, clinical measurement and statistics',
    mockPaperB: 'Paper B',
    mockPaperBTitle: 'Clinical Practice',
    mockPaperBTopic1: 'General anaesthesia',
    mockPaperBTopic2: 'Regional and local anaesthesia',
    mockPaperBTopic3: 'Specialised anaesthesia including pain',
    mockPaperBTopic4: 'Intensive care medicine',
    mockPaperBTopic5: 'Internal medicine',
    mockPaperBTopic6: 'Emergency medicine',
    mockDuration: 'Duration',
    mockDurationPaper: '120 min (paper)',
    mockDurationComputer: '90 min (computer-based)',
    mockStart: 'Start exam',
    mockShortfallTitle: 'Fewer questions than requested',
    mockShortfallLine: '{paper} · {area}: {available} of {requested} available',
    mockResumeTitle: 'Unfinished exam',
    mockResumeBody: 'You have an exam in progress that has not expired.',
    mockResume: 'Resume exam',
    mockHistory: 'Past exams',
    mockHistoryEmpty: 'No completed exams yet.',
    mockSubmitted: 'Submitted',
    mockScore: 'Score',
    mockResultLink: 'Result',
    mockRemaining: 'Time remaining',
    mockFlag: 'Flag',
    mockFlagged: 'Flagged',
    mockSubmit: 'Submit exam',
    mockSubmitShort: 'Submit',
    mockSubmitConfirm: 'Do you really want to submit the exam?',
    mockPartial: 'Partly answered',
    mockAnswered: 'Answered',
    mockNavigator: 'Question overview',
    mockNavigatorSummary: 'Question overview ({answered}/{total} answered, {flagged} flagged)',
    mockResultTitle: 'Result',
    mockPassed: 'Passed',
    mockFailed: 'Not passed',
    mockPassGuide: 'Guide value {threshold} %; the official ESAIC pass mark varies each year',
    mockAreas: 'Points by area',
    mockArea: 'Area',
    mockReview: 'Review',
    mockYourAnswer: 'Your answer',
    mockCorrectIs: 'Correct answer',
    mockBlankAnswer: 'Blank',
    mockHint: 'Hint',
    mockPoint: 'point',
    mockPoints: 'points',
    mockBack: 'Back to mock test',
    mockTrue: 'True',
    mockFalse: 'False',
    mockLoadError: 'The exam could not be loaded. Please try again.',
    mockSubscriptionTitle: 'Subscription required',
    mockSubscriptionBody: 'An active subscription is required for the mock exam.',
    mockSubscriptionKept: 'Your answers so far stay saved.',
    mockSubscribe: 'Subscribe',
    mockSubmitError: 'The exam could not be submitted. Please try again.',
    mockTimeUp: 'Time is up. Your answers are being submitted.',
    mockSelectPaper: 'Please choose a paper.',
    mockArea_statistics: 'Statistics',
    mockArea_physiology: 'Physiology',
    mockArea_pharmacology: 'Pharmacology',
    mockArea_physics: 'Physics and clinical measurement',
    mockArea_general_anaesthesia: 'General anaesthesia',
    mockArea_regional_anaesthesia: 'Regional and local anaesthesia',
    mockArea_special_anaesthesia: 'Specialised anaesthesia',
    mockArea_intensive_care: 'Intensive care medicine',
    mockArea_internal_medicine: 'Internal medicine',
    mockArea_emergency_medicine: 'Emergency medicine',
};